import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'ds-report-table-header',
  templateUrl: './report-table-header.component.html',
  styleUrls: ['./report-table-header.component.scss']
})
export class ReportTableHeaderComponent implements OnInit {

  @Input() title: string;
  @Input() subtitle: string;

  constructor() { }

  ngOnInit() {
  }

}
